import React from "react";
import CompanyAtomikaPage from "@components/Pages/CompanyAtomikaPage/CompanyAtomikaPage";

export default function Software() {
    return <CompanyAtomikaPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
